"use strict";

const angular = require("angular");
require("jquery");
require("ngstorage");
require("angular-ui-router");
require("angular-bootstrap");
require("ui-select");
require("angular-ui-switch");
require("angular-ui-mask");
require("angular-ui-validate");
require("angular-dynamic-locale");
require("angular-translate");
require("angular-translate-loader-static-files");
require("@tce/kobe-oidc");
require("moment");
require("angular-file-saver");

angular
  .module("Finance", [
    "ngStorage",
    "ui.router",
    "ui.bootstrap",
    "ui.select",
    "uiSwitch",
    "ui.mask",
    "ui.validate",
    "tmh.dynamicLocale",
    "pascalprecht.translate",
    "kobeOIDC",
    "ngFileSaver"
  ])

  // Settings
  .constant("DefaultLanguage", "en")
  .constant("AvailableLanguages", ["en", "cs", "sk", "hu"])
  .constant("AppMode", {
    Development: 0,
    Test: 1,
    Production: 2
  })

  // Config
  .config([
    "$locationProvider",
    "$sceDelegateProvider",
    "tmhDynamicLocaleProvider",
    "$translateProvider",
    "$stateProvider",
    "$httpProvider",
    function (
      $locationProvider,
      $sceDelegateProvider,
      tmhDynamicLocaleProvider,
      $translateProvider,
      $stateProvider,
      $httpProvider
    ) {
      $httpProvider.defaults.useXDomain = true;

      delete $httpProvider.defaults.headers.common["X-Requested-With"];

      // Allowed urls
      $sceDelegateProvider.resourceUrlWhitelist(["self"]);

      // Localization and translations
      tmhDynamicLocaleProvider.localeLocationPattern(
        "/js/localization/Finance.Locale.{{locale}}.js"
      );

      $translateProvider.useSanitizeValueStrategy("escaped");
      $translateProvider.useStaticFilesLoader({
        prefix: "/js/localization/",
        suffix: ".json"
      });

      $locationProvider.html5Mode(true);

      // Routing
      $stateProvider
        .state("index", {
          url: "",
          controller: "homeController",
          template: require("../Templates/home.html")
        })
        .state("invoice-browse", {
          url: "/invoice-browse",
          controller: "invoiceBrowseController",
          template: require("../Templates/invoiceBrowse.html")
        })
        .state("invoice-browse.search", {
          url: "/invoiceNo/{invoiceNo}",
          controller: "invoiceBrowseController",
          template: require("../Templates/invoiceBrowse.html"),
          resolve: {
            invoiceNo: [
              "$stateParams",
              function ($stateParams) {
                return $stateParams.invoiceNo;
              }
            ]
          }
        })
        .state("audit", {
          url: "/audit",
          controller: "auditController",
          template: require("../Templates/audit.html")
        })
        .state("missing-oracle-code", {
          url: "/missing-oracle-code",
          controller: "missingOracleCodeController",
          template: require("../Templates/missingOracleCode.html")
        });
    }
  ])

  // Date picker hot fix
  .directive("datepickerPopup", [
    "dateFilter",
    "datepickerPopupConfig",
    function (dateFilter, datepickerPopupConfig) {
      return {
        restrict: "A",
        priority: 1,
        require: "ngModel",
        link: function (scope, element, attr, ngModel) {
          var dateFormat =
            attr.datepickerPopup || datepickerPopupConfig.datepickerPopup;
          ngModel.$formatters.push(function (value) {
            return dateFilter(value, dateFormat);
          });
        }
      };
    }
  ])

  // Bind attribute
  .directive("ngBindAttrs", function () {
    return function (scope, element, attrs) {
      scope.$watch(
        attrs.ngBindAttrs,
        function (value) {
          angular.forEach(value, function (value, key) {
            attrs.$set(key, value);
          });
        },
        true
      );
    };
  });

angular.isUndefinedOrNull = function (val) {
  return angular.isUndefined(val) || val === null;
};

angular.isUndefinedNullOrEmpty = function (val) {
  return angular.isUndefined(val) || val === null || val.length === 0;
};

require("./Controllers/auditController");
require("./Controllers/homeController");
require("./Controllers/invoiceBrowseController");
require("./Controllers/mainController");
require("./Controllers/missingOracleCodeController");
require("./Controllers/userSettingsController");

require("./Services/Auth");
require("./Services/activityService");
require("./Services/fileService");
require("./Services/languageService");
require("./Services/notificationService");
require("./Services/UserService");

require("../Styles/Site.less");
